// Lib
import React from 'react';

// Components
import { ReactComponent as List } from '../../../assets/svg/list.svg';

// Styles
import { useStyles } from './ListButtonStyles';

const ListButton = ({ isActive, className, ...props }) => {
  const { classes, cx } = useStyles();

  return (
    <List
      id="list-button"
      className={cx(classes.root, isActive && classes.active, className)}
      {...props}
    />
  );
};

export default ListButton;
